var map = {
	"./white_0.png": "153c",
	"./white_1.png": "be05",
	"./white_2.png": "b42c",
	"./white_3.png": "0969",
	"./white_4.png": "4066",
	"./white_5.png": "9d96",
	"./white_6.png": "587f",
	"./white_7.png": "1110",
	"./white_8.png": "e735",
	"./white_9.png": "10f6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ad8";